// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
require('pubnub');

const deps = [];

module.exports = angular
  .module('bench.config.pubnub', deps)

  .factory('Pubnub', () => PUBNUB);
